import { Grid } from '@mui/material';
import useAuth from 'hooks/useAuth';
import useClinicDocuments from 'hooks/useClinicDocuments';
import useFormBuilder from 'hooks/useFormBuilder';
import useFormBuilderTemplate from 'hooks/useFormBuilderTemplate';
import { useModal } from 'mui-modal-provider';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { store } from 'store';
import { RESET_FIELDS, SET_ITEMS } from 'store/actions';
import { DefaultRootStateProps } from 'types';
import MainCard from 'ui-component/cards/MainCard';
import { v4 as uuid } from 'uuid';
import ConfirmationDialog from '../modals/ConfirmationDialog';
import DragArea from './DragArea';
import Elements from './Elements';
import NewProperties from './NewProperties';

const DefaultForm = () => {
  const formRef = useRef<any>();
  const propertiesRef = useRef<any>();
  const { state } = useLocation();
  const formData = useSelector((state: DefaultRootStateProps) => state.formBuilder);
  const { formId, isFromTemplate, templateId, isEditing, isClinicDocuments, documentId, targetAudience } = state as any;
  const intl = useIntl();
  const { userId } = useAuth();
  const navigate = useNavigate();
  const { createForm, updateForm, refetchForms } = useFormBuilder({ userId });
  const { createTemplate, updateTemplate } = useFormBuilderTemplate({ userId });
  const { createCustomTemplate, createCustomForm, isCreatingCustomForm, isCreatingCustomTemplate, refetchDocuments } = useClinicDocuments();

  // const language = {
  //   english: true
  // };
  const [items, setItems] = useState<any>([]);

  const [draggedItem, setDraggedItem] = useState<any>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const { showModal } = useModal();
  const handleAdd = useCallback(() => {
    const modal = showModal(ConfirmationDialog, {
      onConfirm: () => {
        let scoreBased = formData?.scoreBased;
        const formItems = formData.items?.map((item) => {
          if (item?.addScores && scoreBased !== true) {
            scoreBased = true;
          }
          console.log(item, 'ITEM');
          return {
            _id: item?._id,
            id: item?.id,
            width: item?.width,
            label: item?.label,
            labelFrench: item?.labelFrench,
            description: item?.description,
            type: item?.type,
            small: item?.small,
            mandatory: item?.mandatory,
            items: item?.items,
            addScores: item?.addScores,
            legend: item?.legend,
            choices: item?.choices,
            legendRadioValue: item?.legendRadioValue,
            multiple: item?.multiple,
            showInput: item?.showInput,
            inputsLabel: item?.inputsLabel,
            inputsLabelFrench: item?.inputsLabelFrench,
            vertical: item?.vertical,
            preset: item?.preset,
            bold: item?.bold,
            italic: item?.italic,
            textAlign: item?.textAlign,
            underline: item?.underline,
            fontSize: item?.fontSize,
            logoSize: item?.logoSize
          };
        });
        const steps = formData.steps?.map((step) => {
          return {
            _id: step?._id,
            title: step.title,
            titleFrench: step.titleFrench,
            items: step.items?.map((item) => {
              if (item?.addScores && scoreBased !== true) {
                scoreBased = true;
              }
              return {
                _id: item?._id,
                id: item?.id,
                width: item?.width,
                label: item?.label,
                labelFrench: item?.labelFrench,
                description: item?.description,
                type: item?.type,
                small: item?.small,
                mandatory: item?.mandatory,
                items: item?.items,
                addScores: item?.addScores,
                legend: item?.legend,
                choices: item?.choices,
                legendRadioValue: item?.legendRadioValue,
                multiple: item?.multiple,
                showInput: item?.showInput,
                inputsLabel: item?.inputsLabel,
                inputsLabelFrench: item?.inputsLabelFrench,
                vertical: item?.vertical,
                preset: item?.preset,
                bold: item?.bold,
                italic: item?.italic,
                textAlign: item?.textAlign,
                underline: item?.underline,
                fontSize: item?.fontSize,
                logoSize: item?.logoSize
              };
            })
          };
        });
        const form = { ...formData, steps, items: formItems, scoreBased };
        delete form?.formId;
        delete form?.templateId;

        if (isFromTemplate) {
          delete form?.template;

          if (formData?.templateId || templateId) {
            updateTemplate({
              payload: { ...form },
              templateId: formData.templateId ?? templateId
            });
          } else {
            if (isClinicDocuments) {
              // Remove templateId and formId when isClinicDocuments is true
              const { templateId, formId, ...restForm } = form;
              createCustomTemplate({ ...restForm, documentId: formData?.documentId, userId, targetAudience });
            } else {
              const { documentId, ...restForm } = form;
              createTemplate({ ...restForm });
            }
          }
        } else {
          delete form?.isForNotes;
          delete formData?.isForNotes;
          if (formData?.formId || templateId || formId) {
            const { documentId, ...restFormData } = form;
            // console.log('inside update form with formid as ', formId, formData?.formId);
            updateForm({
              payload: { ...restFormData },
              formId: formId || formData?.formId || null
            });
            refetchDocuments();
          } else {
            // console.log('isClinicDocuments documents ', isClinicDocuments);
            if (isClinicDocuments) {
              const { templateId, formId, ...restForm } = form;
              // console.log('target audience ', targetAudience);
              createCustomForm({ ...restForm, documentId: formData?.documentId, userId, targetAudience: targetAudience });
              refetchDocuments();
              refetchForms();
            } else {
              const { documentId, ...restForm } = form;
              createForm({ ...restForm });
            }
          }
        }
        modal.hide();

        //call rest api and send data to BE
        console.log('is clinic documents ', isClinicDocuments);
        if (isClinicDocuments) {
          navigate('/clinic-documents');
        } else {
          navigate('/forms');
        }
        store.dispatch({ type: RESET_FIELDS });
      },
      onCancel: () => {
        modal.hide();
      },
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      description: isEditing
        ? intl.formatMessage({ defaultMessage: 'You want to confirm & update this Form?' })
        : intl.formatMessage({ defaultMessage: 'You want to confirm & create this Form?' })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, formData.items]);
  const handleDragStart = (e, item) => {
    setDraggedItem(item);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = (e) => {
    e.preventDefault();

    let elementIndex = 0;
    let heightSum = 0;
    if (formRef?.current && formRef?.current?.children) {
      const formTop = e.clientY - formRef.current.getBoundingClientRect().top;

      for (let i = 0; i < formRef.current.children.length; i++) {
        if (heightSum > formTop) {
          break;
        }
        var childIndex = i + 2;
        if (items[i]?.width === 12) {
          elementIndex = i + 1;
        } else {
          elementIndex = i + childIndex;
        }

        heightSum += formRef.current.children[i].clientHeight + 20;
      }
    }
    if (draggedItem) {
      var obj = {
        id: uuid(),
        type: draggedItem.type,
        label: draggedItem.type === 'Logo' ? '' : draggedItem?.label,
        width: 12,
        multiple: draggedItem.multiple
      };

      setItems((pre: any) => {
        pre.splice(elementIndex, 0, obj);
        store.dispatch({ type: SET_ITEMS, payload: pre });

        return pre;
      });
      setTimeout(() => {
        setDraggedItem(null);
        setSelectedItem(obj);
      }, 500);
    }
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!(formRef.current.contains(e.target) || propertiesRef.current?.contains(e.target))) {
        setSelectedItem(null);
      }
    };

    document.body.addEventListener('click', handleClickOutside);

    return () => {
      document.body.removeEventListener('click', handleClickOutside);
    };
  }, [formRef, setSelectedItem]);

  useEffect(() => {
    if (formData && formData?.items) {
      setItems(formData.items);
    }
  }, [formData]);

  return (
    // <FormLocales>
    <Grid container direction="row" gap={0.5} justifyContent="space-between">
      <Grid item xs={12} md={8}>
        <DragArea
          items={items}
          setItems={setItems}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          formRef={formRef}
          handleDragOver={handleDragOver}
          handleDrop={handleDrop}
          steps={formData?.steps ?? []}
          defaultStepName={formData?.defaultStepName}
          type={formData?.type}
        />
      </Grid>
      <Grid item xs={12} md={3.9}>
        {selectedItem ? (
          <NewProperties
            propertiesRef={propertiesRef}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            items={items}
            setItems={setItems}
            formData={formData}
            language={formData?.lng}
            isDashboard={false}
          />
        ) : (
          <MainCard content={false}>
            <Elements
              isEditing={isEditing}
              handleDragStart={handleDragStart}
              handleAdd={handleAdd}
              isFromStepper={false}
              disabled={!(items?.length > 0)}
            />
          </MainCard>
        )}
      </Grid>
    </Grid>
    // </FormLocales>
  );
};

export default DefaultForm;
